import * as hasOwn from 'object.hasown';

// Pingdom's browser does not support Object.hasOwn.
if (!Object.hasOwn) {
  hasOwn.shim();
}
